import { DomSanitizer } from '@angular/platform-browser';
import { AnalyticsBaseReportDashboard, AnalyticsBaseReportResponse } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { InlineListSectionHandler, InlineListItem } from '../shared/inline-list.section';

export interface ListSectionValues {
    items: any;
}

export interface DashboardListItem extends InlineListItem {
    data: AnalyticsBaseReportDashboard;
}


export class AnalyticsDashboardListSectionHandler extends InlineListSectionHandler<AnalyticsBaseReportResponse> {

    emptyText = this.translate('MESSAGES.EMPTY_LIST');
    maxReports = 10;
    maxAssets = 6;

    actionAdd = false;
    actionDelete = false;
    actionReload = false;


    constructor(
        admin: AdminEditorService,
        ownerId: string,
        private sanitizer: DomSanitizer
    ) {
        super(admin, ownerId);
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ANALYTICSBASEREPORT.DASHBOARDS.${key}`, values);
    }

    async getItems(entity: AnalyticsBaseReportResponse, _offset: number, _limit: number): Promise<DashboardListItem[]> {
       
        return entity.dashboards?.map(item => {
            return {
                id: item.id,
                name: item.owner.name,
                description: this.sanitizer.bypassSecurityTrustHtml(`<a href="/#/admin/${item.owner.type}/${item.owner.id}/dashboards/grid/dashboard/${item.id}">${item.name}</a>`),
                icon: 'file-alt',
                data: item,
            };
        });
    }

    async actionClicked(_action: string, entity: AnalyticsBaseReportResponse, _item: DashboardListItem): Promise<AnalyticsBaseReportResponse> {
        return entity;
    }
    
    
}
